module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "subscription-result-modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    class: ['modal-dialog',
      {
        'loading-dialog': _vm.loading
      },
      {
        'success-dialog': !_vm.loading && _vm.subscriptionInfo.status === 'active'
      },
      {
        'failure-dialog': !_vm.loading && _vm.subscriptionInfo.status !== 'active'
      }
    ],
    attrs: {
      "role": "document"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "modal-content",
    attrs: {
      "id": "loading"
    }
  }, [_c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  })], 1) : (_vm.subscriptionInfo.status === 'active') ? _c('div', {
    staticClass: "modal-content",
    attrs: {
      "id": "success"
    }
  }, [_c('modal-header'), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/dashboard/success_2x.png",
      "alt": " "
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('subscribedSuccessfully')))]), _vm._v(" "), _c('p', {
    staticClass: "payment-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('price')))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.subscriptionInfo.package_detail.currency_code)) + " " + _vm._s(_vm.subscriptionInfo.package_detail.price))])]), _vm._v(" "), _c('p', {
    staticClass: "payment-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('deviceNum')))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.subscriptionInfo.package_detail.device_count) + " " + _vm._s(_vm.$tc('devices', _vm.subscriptionInfo.package_detail.device_count)))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.gtmEvent('subscribe_success')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('sure')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('reviewNotice')))])])], 1) : (_vm.subscriptionInfo.status !== 'active') ? _c('div', {
    staticClass: "modal-content",
    attrs: {
      "id": "failed"
    }
  }, [_c('modal-header'), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/dashboard/failure_2x.png",
      "alt": " "
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('subscribedFailure')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('queryNotice')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.gtmEvent('subscribe_fail')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('sure')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('contactUs')))]), _vm._v(" "), _c('p', {
    staticClass: "email"
  }, [_vm._v("iplexservice@gmail.com")])])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-698283be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subscription/subscribeResult/SubscribeResult.vue
// module id = 1344
// module chunks = 1